<template lang="html">
  <div class="main elevation-1">
    <div class="result">
      <v-tabs v-model="active" fixed-tabs background-color="primary">
        <v-tab v-for="(detail, idx) in resultDetails" :key="detail.title + idx" :href="'#' + detail.title" ripple>
          <h2>{{detail.title}}</h2>
        </v-tab>
        <v-tab-item v-for="(detail, idx) in resultDetails" :key="detail.title + idx" :id="detail.title">
          <div v-if="detail.type === 'text'" style="padding: 15px;">
            <p class="query">{{ detail.query }}</p>
            <p class="result">{{ detail.result }}</p>
          </div>
          <div v-else-if="detail.type === 'pdf'">
            <vue-pdf-viewer :url="detail.src" height="90vh" name="pdfviewer"></vue-pdf-viewer>
          </div>
          <div v-else-if="detail.type === 'mp3'">
            <div align="center" height="100vh" style="padding-top: 100px;">
              <audio controls controlsList="nodownload" preload="auto">
                <source :src="detail.src" type="audio/mpeg" />
              </audio>
            </div>
          </div>
          <div v-else-if="detail.type === 'img'">
            <viewer>
              <img :src="detail.src" :alt="detail.title" width="100%" class="image">
            </viewer>
          </div>
          <div v-else-if="detail.type === 'mp4'">
            <div align="center" height="100vh" style="padding-top: 100px;">
              <video width="640" height="480" controls>
                <source :src="detail.src" type="video/mp4">
              </video>
            </div>
          </div>
          <div v-else>
            Error.
          </div>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VuePDFViewer from './VuePDFViewer'

export default {
  data () {
    return {
      active: 'tab-0'
    }
  },
  components: {
    'vue-pdf-viewer': VuePDFViewer
  },
  computed: {
    ...mapGetters({
      caseId: 'getCaseId',
      encounterId: 'getEncounterId',
      resultDetails: 'resultDetails'
    })
  },
  watch: {
    resultDetails: {
      deep: true,
      handler (r) {
        this.active = 'tab-0'
      }
    }
  }
}
</script>

<style lang="css">
.main {
  height: 100%;
  width: 100%;
  /* border: 2px solid blue; */
}
.query {
  padding-top: 30px;
  padding-bottom: 10px;
  font-size: 1.5em;
  color: blue;
}
.result {
  font-size: 1.2em;
  color: green;
}
.image {
  /* width: calc(20% - 10px); */
  /* max-width: 100%; */
  /* max-height: 100%; */
  /* width: calc(30% - 10px); */
  height: 500px;
  object-fit: contain;
  /* width: 50%; */
  cursor: pointer;
  margin: 5px;
  display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Case/components/QueryResult.vue